import { useParams } from 'react-router-dom';
import type { MailingLanguageCode } from '@zimpel/common/config';
import { defaultLanguageCode, isMailingLanguageCode } from '@zimpel/common/config';

const useLanguageParam = (): MailingLanguageCode => {
  const { language } = useParams<{ language: string }>();

  return language && isMailingLanguageCode(language) ? language : defaultLanguageCode;
};

export default useLanguageParam;
